import React from "react";

import "./Page.css";

const Page = ({ children }) => {
  return <div className="page">{children}</div>;
};

export default Page;
